<template>
  <div class="countdown-timer">
    <p v-if="remainingTime > 0">
      Next personalized reading available in: <strong>{{ formattedTime }}</strong>
    </p>
    <p v-else>
      You can now request a new reading!
    </p>
  </div>
</template>

<script>
export default {
  props: {
    payload: Object
  },
  data() {
    return {
      remainingTime: 0,
      intervalId: null
    }
  },
  computed: {
    formattedTime() {
      const hours = Math.floor(this.remainingTime / 3600)
      const minutes = Math.floor((this.remainingTime % 3600) / 60)
      const seconds = this.remainingTime % 60
      return `${hours}h ${minutes}m ${seconds}s`
    }
  },
  mounted() {
    const targetTime = new Date(this.payload.available_at).getTime()
    this.intervalId = setInterval(() => {
      const now = new Date().getTime()
      const diff = Math.floor((targetTime - now) / 1000)
      this.remainingTime = Math.max(0, diff)
      if (this.remainingTime === 0) clearInterval(this.intervalId)
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>
.countdown-timer {
  text-align: center;
  font-size: 14px;
  color: #663399;
  padding: 2px;
  border: 2px solid #663399;
  background: #f3e8ff;
  border-radius: 2px;
  margin-top: 2px;
}
</style>